import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media } from '@clds/style-utils';
import { asStyledComponent } from '@clds/component-enhancer';
import { Title } from './components/Title';
import { SearchSubheader } from './components/SearchSubheader';
import { Search } from './components/Search';

const BaseElement = styled.div`
  max-width: 100%;
  display: flex;
  flex-flow: column;

  @media ${media.tablet({ maxOnly: true })} {
    min-height: auto;
    min-height: -webkit-fit-content;
  }

  @media ${media.tablet({ maxOnly: true })} {
    flex-wrap: wrap;
  }
`;

export const Root = styled(BaseElement)`
  width: 100%;
  background-color: ${globalTheme.palette.surface};
`;

export const Container = styled(BaseElement)`
  margin: 0 auto;
`;

export const SearchWrapper = styled.div`
  width: 100%;
  display: flex;

  @media ${media.tablet({ maxOnly: true })} {
    flex-flow: column;
    flex-wrap: wrap;
  }
`;

export const PageHeaderCompoundParent = asStyledComponent(({ children, ...restProps }: { children: ReactNode }) => <Root {...restProps}>{children}</Root>);

export const PageHeader = Object.assign(PageHeaderCompoundParent, {
  Container,
  Title,
  SearchSubheader,
  Search,
  SearchWrapper,
});
